export let hoursOptions = [
    {
        label: '08:30 AM',
        value: '08:30 AM'
    },
    {
        label: '09:00 AM',
        value: '09:00 AM'
    },
    {
        label: '09:30 AM',
        value: '09:30 AM'
    },
    {
        label: '10:00 AM',
        value: '10:00 AM'
    },
    {
        label: '10:30 AM',
        value: '10:30 AM'
    },
    {
        label: '11:00 AM',
        value: '11:00 AM'
    },
    {
        label: '11:30 AM',
        value: '11:30 AM'
    },
    {
        label: '12:00 PM',
        value: '12:00 PM'
    },
    {
        label: '12:30 PM',
        value: '12:30 PM'
    },
    {
        label: '01:00 PM',
        value: '01:00 PM'
    },
    {
        label: '01:30 PM',
        value: '01:30 PM'
    },
    {
        label: '02:00 PM',
        value: '02:00 PM'
    },
    {
        label: '02:30 PM',
        value: '02:30 PM'
    },
    {
        label: '03:00 PM',
        value: '03:00 PM'
    },
    {
        label: '03:30 PM',
        value: '03:30 PM'
    },
    {
        label: '04:00 PM',
        value: '04:00 PM'
    },
    {
        label: '04:30 PM',
        value: '04:30 PM'
    },
    {
        label: '05:00 PM',
        value: '05:00 PM'
    },
    {
        label: '05:30 PM',
        value: '05:30 PM'
    },
    {
        label: '06:00 PM',
        value: '06:00 PM'
    },
];
export function getFormatter() {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
    });
    return function (value) {
        if (!value) {
            value = 0;
        }
        return formatter.format(value);
    };
}
export function getSubtotal(items) {
    return items.reduce((sTotal, item) => sTotal + (item.quantity * (item.price / (1 + item.tax))), 0);
}
export function getTotal(items) {
    return items.reduce((sTotal, item) => sTotal + (item.quantity * item.price), 0);
}
export function getLastDay(year, month) {
    return new Date(year, month + 1, 0);
}
